import { ErrorMessageCode, JourneyTree } from './FREnums';

export const ERROR_MESSAGE_USER_ACCOUNT_LOCKED_OUT = `User Locked Out.`;

export const authenticatedJourneyTree: Partial<Record<JourneyTree, string>> = {
  [JourneyTree.FR_JOURNEY_CHANGE_PASSWORD]: `AuthenticatedPaswordChange`,
  [JourneyTree.FR_JOURNEY_CHANGE_PASSWORD_V2]: `AuthenticatedPaswordChangeV2`,
  [JourneyTree.FR_JOURNEY_CHANGE_USERNAME]: `AuthenticatedUsernameChange`,
  [JourneyTree.FR_JOURNEY_CHANGE_USERNAME_V2]: `AuthenticatedUsernameChangeV2`,
  [JourneyTree.FR_JOURNEY_REGISTER_MFA]: `AuthenticatedRegisterMfa`,
  [JourneyTree.FR_JOURNEY_REGISTER_MFA_V2]: `AuthenticatedRegisterMfaV2`,
  [JourneyTree.FR_JOURNEY_DISABLE_MFA]: `AuthenticatedDisableMfa`,
  [JourneyTree.FR_JOURNEY_DISABLE_MFA_V2]: `AuthenticatedDisableMfaV2`
};

export const FRErrorMessage: Record<ErrorMessageCode, string> = {
  [ErrorMessageCode.CMCAccountInactive]: `CMCAccountInactive`,
  [ErrorMessageCode.CMCAccountLocked]: `CMCAccountLocked`,
  [ErrorMessageCode.CMCBrandMismatch]: `CMCBrandMismatch`,
  [ErrorMessageCode.CMCUserExitError]: `CMCUserExitError`,
  [ErrorMessageCode.Unknown]: `Unknown`
};

export const MessageToCode: Record<string, ErrorMessageCode> = {
  [ERROR_MESSAGE_USER_ACCOUNT_LOCKED_OUT]: ErrorMessageCode.CMCAccountLocked
};

export const FR_WEB_OAUTH_CLIENT = `CMCMarketsInvestWebFalcon2`; // gitleaks:allow
export const FR_REALM_PATH = `alpha`;
export const FR_SCOPES = `standard privileged`;

// FR flow headers.
export const HEADER_FR_X_APP_CLIENT_ID = `x-app-client-id`;
export const HEADER_FR_X_APP_BRAND = `x-app-brand`;

// session timeout error.
export const ERROR_CODE_SESSION_TIMEOUT = `110`;
